import React from 'react';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

export type SiteNotificationItem = {
  id: number;
  message: string;
  expiration: number;
  siteId?: number | null;
};

function isStillActive(notification: SiteNotificationItem): boolean {
  const nowSeconds = Math.floor(Date.now() / 1000);
  return notification.expiration > nowSeconds;
}

type Props = {
  notifications: SiteNotificationItem[];
  dismissedIds: Set<number>;
  onDismiss: (id: number) => void;
  closeLabel: string;
};

export const SiteNotificationsAlerts: React.FC<Props> = ({
  notifications,
  dismissedIds,
  onDismiss,
  closeLabel,
}) => {
  const visible = notifications.filter(
    (n) => !dismissedIds.has(n.id) && isStillActive(n)
  );
  if (visible.length === 0) {
    return null;
  }
  return (
    <Stack spacing={1} sx={{ width: '100%' }}>
      {visible.map((n) => (
        <Alert
          key={n.id}
          severity="warning"
          onClose={() => onDismiss(n.id)}
          componentsProps={{
            closeButton: {
              'aria-label': closeLabel,
              title: closeLabel,
            },
          }}
        >
          {n.message}
        </Alert>
      ))}
    </Stack>
  );
};
